import { Box } from "@mui/material";

export function ImmunizationsPage() {
  return <Box sx={{ p: 2 }}>Immunizations page</Box>;
}
